import React, { useState, useMemo, useEffect } from 'react';
import { Button, Divider, message, Popover, Typography, Tooltip, Tag } from 'antd';
import Card from '@/components/card';
import './index.less';
import moment from 'moment';
import { cardActivityTypesMap } from '../../constants/card-activty-type';
import { InfoCircleOutlined, StarFilled, StarOutlined } from '@ant-design/icons';
import { enhancedFormateTimeStamp, formateTimeStampToSecondPrecision as noMillisecond } from '@/common/utils';
import goto from '@/common/goto';
import Dongdong from '@/components/dongdong';
import { cancel } from '@/apis/generic/mac/square/collect/cancel';
import { collect as collectFetch } from '@/apis/generic/mac/square/collect';
import ComponentLog from '@/components/component-log';
import classnames from 'classnames';
import { collectLog } from '@/pages/all-about-me/components/signed-activity/log.js';
import ToolTipWithTag, { RenderTagNames, renderActivityTypeTags } from './components/ToolTipWithTag';
import { useDripSource } from '@/apis/dripDataSource';
import RenderZongcuIcon from './components/RenderZongcuIcon';

const { Paragraph } = Typography;

export default function CardItem(props) {
  const { data, loading } = props;

  const {
    hdActivityLevelName,
    benefitTagList,
    activityFeatureTags,
    cardActivityName,
    cardActivityType,
    cardActivityDesc,
    introduction, // 活动利益简介，主要是会场活动和综促活动有
    cardApplyBeginTime,
    appliedFlag,
    canApplyFlag,
    collectionFlag,
    cardApplyEndTime,
    channelId,
    channelPic,
    channelName,
    channelRemark,
    channelType,
    channelLeaderName,
    channelLeaderErp,
    planCode,
    hdActivityName,
    hdActivityStartTime,
    hdActivityEndTime,
    businessStartTime,
    businessEndTime,
    marketSceneTags,
    activityTypeTags,
    demoImgUrl,
    cardId,
    id, // 收藏接口要用的id
    pendingActivityBeginTime,
    pendingActivityEndTime,
  } = data;

  // drip数据源
  const [getDripSource, dripSource] = useDripSource();
  const isGoNewRoomList = getDripSource('useNewOpenApplyVersionInErp', '0') == '1';

  // 展示秒杀开放报名样式
  const showBgColor = () => {
    return activityTypeTags && activityTypeTags.find((ele) => ele.code === 'show_bg_color');
  };
  // 展示百亿补贴样式
  const showBillionStyle = () => {
    return activityTypeTags && activityTypeTags.find((ele) => ele.code === 'billion_bg_color');
  };

  const [collect, setCollect] = useState(collectionFlag);

  useEffect(() => {
    setCollect(collectionFlag);
  }, [collectionFlag]);

  const changeCollectFunc = useMemo(() => {
    if (collect == 1) return cancel;
    return collectFetch;
  }, [collect]);

  const changeCollectStatus = () => {
    const info = {
      fail: collect == 1 ? '取消收藏失败' : '收藏失败',
      success: collect == 1 ? '取消收藏成功' : '收藏成功',
    };

    changeCollectFunc({ pinCardId: id })
      .then((res) => {
        const { ret, msg } = res;
        if (ret != '0') throw msg || info.fail;
        message.success(info.success);
        setCollect((collect) => (collect == 1 ? 0 : 1));
      })
      .catch((ex) => {
        message.error(ex);
      });
  };

  const cardFooter = () => {
    const now = noMillisecond(moment().valueOf());
    let timeInfo = '';
    let btnInfo = '';
    let time = getSignStatus().time;
    let signStatus = getSignStatus().status;
    function getSignStatus() {
      if (canApplyFlag != 1) {
        //这个问题出现的原因就是秒杀那边删了资源的时候，报名截止时间给shihao传的null，但是shihao那边不能把null更新到数据库里面，
        //所以李乾直接给我们返回的是老的报名截止时间，他们就通过更新canApplyFlag字段告诉我们是不是结束了
        return { status: 'endSign', time: 0 };
      }
      if (!cardApplyEndTime || now >= noMillisecond(moment(cardApplyEndTime).valueOf())) {
        // 秒杀卡片有可能不给传报名截止时间，这时直接判定结束
        // 报名截止
        return { status: 'endSign', time: 0 };
      }
      if (!cardApplyBeginTime || now < noMillisecond(moment(cardApplyBeginTime).valueOf())) {
        // 报名未开始，未截止
        return { status: 'beforeSign', time: noMillisecond(moment(cardApplyBeginTime).valueOf()) - now };
      }
      if (canApplyFlag == 0) {
        // 不可报名，未截止
        return { status: 'endSign', time: 1 };
      }
      if (appliedFlag == 1) {
        // 已报名，未截止
        return { status: 'signed', time: noMillisecond(moment(cardApplyEndTime).valueOf()) - now };
      }
      if (canApplyFlag == 1) {
        // 可报名，未截止
        return { status: 'notSign', time: noMillisecond(moment(cardApplyEndTime).valueOf()) - now };
      }
      return { status: 'endSign', time: 0 };
    }

    const getStatus = cardActivityTypesMap[cardActivityType].getStatus;
    timeInfo = getStatus(data)[signStatus].timeInfo;
    btnInfo = getStatus({ ...data, isGoNewRoomList: isGoNewRoomList })[signStatus].button;

    return (
      <>
        <div className="__left">{timeInfo && timeInfo(time)}</div>
        <div className="__right">
          <ComponentLog>
            <span
              clstag="yx_center_1629184833805|87"
              onClick={(e) => {
                collectLog(cardId);
                e.nativeEvent.stopPropagation();
                changeCollectStatus();
              }}
            >
              {collect == 1 ? <StarFilled style={{ color: '#feb00e' }} /> : <StarOutlined />}
            </span>
          </ComponentLog>

          {loading ? <Button key="loadbtn" style={{ width: 90 }} shape="round" loading={true} /> : btnInfo}
        </div>
      </>
    );
  };
  const tagRender = () => {
    // activityTypeTags是优惠券等活动类型信息
    // marketSceneTags是营销场景，例如主题活动
    let tagNames = {};

    if (marketSceneTags && marketSceneTags[0] && marketSceneTags[0].name) {
      //code为:"channel_activity"(其他频道)时, 需要使用接口: 采销端-批量查资源广场活动其他信息中的channelName字段来替换标签名称(name)字段
      let realName = marketSceneTags[0].code == 'channel_activity' ? channelName : marketSceneTags[0].name;
      if (realName) tagNames.marketSceneTags = [realName];
    }
    if (activityTypeTags) {
      tagNames.activityTypeTags = [];
      activityTypeTags.forEach((ele) => {
        if (ele.name) tagNames.activityTypeTags.push(ele.name);
      });
    }

    // 标签toolTip内容
    let tagInfoArr = [];

    if (planCode) {
      tagInfoArr.push({ text: activityExtraInfo });
    }
    if (channelId) {
      tagInfoArr.push({ text: channelExtraInfo });
    }

    if (tagNames.activityTypeTags?.length) {
      tagInfoArr.push({ text: renderActivityTypeTags(tagNames.activityTypeTags) });
    }

    try {
      if (marketSceneTags.length) {
        marketSceneTags.forEach((ele) => {
          if (ele.erpIntroduce) tagInfoArr.push(JSON.parse(ele.erpIntroduce));
        });
      }
      if (activityTypeTags.length) {
        activityTypeTags.forEach((ele) => {
          if (ele.erpIntroduce) tagInfoArr.push(JSON.parse(ele.erpIntroduce));
        });
      }
    } catch (ex) {
      console.error(ex);
    }

    if (showBillionStyle()) {
      return (
        <ToolTipWithTag tagInfoArr={tagInfoArr}>
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/135302/23/29745/6735/6406e633F67142f5e/d2d38ae4431cc659.png"
            width={80}
          />
        </ToolTipWithTag>
      );
    }

    return (
      <ToolTipWithTag tagInfoArr={tagInfoArr}>
        <span>
          <RenderTagNames
            tagNames={tagNames}
            rightIcon={
              tagInfoArr.length > 0 ? (
                <span className="tip-icon">
                  <InfoCircleOutlined />
                </span>
              ) : null
            }
          />
        </span>
      </ToolTipWithTag>
    );
  };
  const activityExtraInfo = (
    <div className="activity-extra-info">
      <div className="from-info">来自活动</div>
      <div className="info-title">{hdActivityName}</div>
      <div className="info-dec">
        <div>活动级别：{hdActivityLevelName}</div>
        <div>活动编号：{planCode}</div>
        <div>
          活动时间：
          {pendingActivityBeginTime || enhancedFormateTimeStamp(moment(hdActivityStartTime), 'YY-MM-DD hh:mm')} ~{' '}
          {pendingActivityEndTime || enhancedFormateTimeStamp(moment(hdActivityEndTime), 'YY-MM-DD hh:mm')}
        </div>
        <div>
          报名时间：{enhancedFormateTimeStamp(moment(businessStartTime), 'YY-MM-DD hh:mm')} ~{' '}
          {enhancedFormateTimeStamp(moment(businessEndTime), 'YY-MM-DD hh:mm')}
        </div>
      </div>
      <Button type="primary" size="small" ghost onClick={() => goto.merchantActivityDetail(planCode).newTab()}>
        查看详情
      </Button>
      <Divider style={{ margin: '12px 0 0 0' }} />
    </div>
  );
  const channelExtraInfo = (
    <div className="channel-extra-info">
      <div className="from-info">所属频道</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={channelPic} width={30} height={30} style={{ marginRight: 8 }} />
        <div className="info-title">{channelName}</div>
      </div>
      <div className="info-dec ellipsis-2-line">{channelRemark || '暂无频道描述'}</div>
      <div className="channel-leader-info">
        负责人：{channelLeaderName}
        <Dongdong erp={channelLeaderErp} />
      </div>
      <Button
        type="primary"
        ghost
        size="small"
        onClick={() => {
          channelType == 3 && goto.platformDetail(channelId).newTab();
          channelType == 4 && goto.channelList(channelId).newTab();
        }}
      >
        进入频道
      </Button>
      <Divider style={{ margin: '12px 0 0 0' }} />
    </div>
  );

  return (
    <Card
      border
      backgroundColor
      hoverBorder
      container={{ margin: false, padding: true }}
      className={classnames('resource_page_card__item', {
        'show-billion-style': showBillionStyle(),
        show_bg_color: showBgColor(),
      })}
    >
      <ComponentLog>
        <div clstag="yx_center_1629184833805|88" style={{ width: '100%' }}>
          <div style={{ display: 'flex' }}>
            <div className="item__title">
              <Paragraph
                ellipsis={{
                  rows: 1,
                  tooltip: <span>{cardActivityName}</span>,
                }}
              >
                {cardActivityName}
              </Paragraph>
            </div>
            <RenderZongcuIcon data={data} />
          </div>

          {showBillionStyle() && (
            <img
              className="billion-style-joy-info"
              width={160}
              src="//img30.360buyimg.com/pop/jfs/t1/212420/24/26555/2368427/6407214bF0a69479a/dc28b804e4223791.gif"
            ></img>
          )}
          <div className="item__tags">
            <div className="item__tags__tag first_tag">{tagRender()}</div>
            {hdActivityLevelName ? <div className="item__tags__tag">{hdActivityLevelName}</div> : null}
            {benefitTagList?.length > 0 &&
              benefitTagList.map((ele, index) => (
                <div className="item__tags__subTag" key={index}>
                  {ele}
                </div>
              ))}
            {activityFeatureTags?.map((item) => {
              return (
                <ToolTipWithTag
                  key={item.name}
                  tagInfoArr={[
                    {
                      name: item.name,
                      text:
                        '跨品类营销是指跨一级类目的营销活动。目前覆盖了优惠券、平台促销活动类型，后续将会有更多场景拓展。',
                    },
                  ]}
                >
                  <Tag style={{ lineHeight: '18px', marginLeft: '8px' }} color="default">
                    <span style={{ paddingRight: 4 }}>{item.name}</span>
                    <InfoCircleOutlined />
                  </Tag>
                </ToolTipWithTag>
              );
            })}
          </div>
          <div className="item__remark">
            <Paragraph ellipsis={{ rows: 2, tooltip: <span>{introduction || cardActivityDesc || ''}</span> }}>
              {introduction || cardActivityDesc || ''}
            </Paragraph>
          </div>
          <div className="item__act-time">
            <Paragraph
              ellipsis={{
                rows: 1,
                tooltip: <span>活动时间：{cardActivityTypesMap[cardActivityType].getCardActTime(data)}</span>,
              }}
            >
              活动时间：{cardActivityTypesMap[cardActivityType].getCardActTime(data)}
            </Paragraph>
          </div>
          <Divider className="item__divider" />
          <div className="item__footer">{cardFooter()}</div>
        </div>
      </ComponentLog>
    </Card>
  );
}
